import {h} from 'preact';
import FormItem from "./FormItem";
import InputAutocomplete from "./InputAutocomplete";

export default function AddressSuggestion(props){
	const onAutocompleteSelect = (event, ui) => {
		this.props.onSelect(ui.item.city, ui.item.street, ui.item.house);
	};

	const onSelect = (value, displayValue) => {
		if(value.length <= 0)
		{
			this.props.onSelect('', '', '');
		}
	};

	const source = (request, response) => {
		$.ajax({
			url: props.apiUrl,
			dataType: "json",
			method: 'POST',
			data: {
				query: request.term,
				count: 20,
			},
			success: function(data){
				response(data);
			}
		});
	};

	return (
		<FormItem title={props.title} errorsClass={props.error}>
			<InputAutocomplete
				key={'address'}
				placeholder="Укажите адрес"
				autocompleteOptions={{
					minLength: 3,
					source: source,
				}}
				autoSearch={true}
				onSelect={onSelect}
				autocompleteselect={onAutocompleteSelect}
				defaultValue={props.defaultValue}
				defaultDisplayValue={props.defaultDisplayValue}
				valueInputItemKey="value"
			/>
		</FormItem>
	)
}